import * as React from 'react';
import { CardHeader, CardHeaderLeft } from '../../../shared/card/CardHeader';
import { ControlSpacer } from '../../../shared/form/ControlSpacer';
import { Step } from '../../../shared/form/Step';
import { TextArea } from '../../../shared/form/TextArea';
import { TextField } from '../../../shared/form/TextField';
import { FormSection } from './FormSection';

interface IProps {
  step?: number;
  name: string;
  description: string;
  onTemplateNameChange: (v: string) => void;
  onTemplateDescriptionChange: (v: string) => void;
}

export const TemplateMetadata = (props: IProps): React.ReactElement => {
  return (
    <FormSection>
      <CardHeader>
        <CardHeaderLeft>
          {props.step && <Step>{props.step}</Step>}
          <div>
            <h6>Template Info</h6>
          </div>
        </CardHeaderLeft>
      </CardHeader>
      <div style={{ padding: '10px' }}>
        <ControlSpacer>
          <TextField
            name='template_name'
            label='Template Name'
            type='text'
            value={props?.name ?? ''}
            placeholder='Enter a name for the settings template...'
            onChange={props.onTemplateNameChange}
          />
        </ControlSpacer>
        <ControlSpacer>
          <TextArea
            name='template_description'
            label='Description'
            value={props?.description ?? ''}
            placeholder='Enter a description...'
            onChange={props.onTemplateDescriptionChange}
            rows={3}
          />
        </ControlSpacer>
      </div>
    </FormSection>
  );
};
